import axios from 'axios'
import { isBlank, serialize } from '../commons.js'
import ApplicationController from './application_controller.js'
import { XhrLoadingAnimation } from "../lib/xhr_loader"

export default class ReportsController extends ApplicationController {

  static targets = [
    "reportView", "selectedReport"
  ]

  connect() {
    this.xhr_loading_animation = new XhrLoadingAnimation(this.reportViewTarget, 0)
  }

  refresh_filter(e) {
    var form = e.target.closest('form')
    var report_id = this.selectedReportTarget.value
    if (isBlank(report_id)) {
      this.reportViewTarget.innerHTML = ''
      document.body.querySelector('#reports_filter_options').innerHTML = ''
      document.body.querySelector('#report_help').innerHTML = ''
    } else {
      axios.get(`/reports/${report_id}/filter?${serialize(form)}`)
        .then(response => {
          document.body.querySelector('#reports_filter').innerHTML = response.data
          this.reportViewTarget.innerHTML = ''
        })
    }
  }

  show(e) {
    e.preventDefault()

    var form = e.target.closest('form')
    var report_id = form.querySelector('#report_id').value

    if (!isBlank(report_id)) {
      this.reportViewTarget.innerHTML = ''
      this.xhr_loading_animation.start()
      axios.get(`/reports/${report_id}?${serialize(form)}`)
        .then(response => {
          this.xhr_loading_animation.cancel()
          this.reportViewTarget.innerHTML = response.data;
        }).catch((error) => {
          this.xhr_loading_animation.broken()
        })
    }
  }

  export_tofile(e) {
    var form = e.target.closest('form')
    var report_id = form.querySelector('#report_id').value
    e.preventDefault()
    this.visit(`/reports/${report_id}.${e.target.dataset.format}?${serialize(form)}`)
  }

  // Certains reports ont des lignes de données (un)/foldable
  foldable(e) {
    var details = e.target.closest('tr').nextElementSibling

    details.style.display === 'none' ? details.style.display = '' : details.style.display = 'none'
    e.preventDefault()
  }

}